import { render, staticRenderFns } from "./ManagerSubscriptionsIcon.vue?vue&type=template&id=6ed1908a&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports